import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { ShippingTerm, type ShippingTermConstructor } from './ShippingTerm'

export const ShippingTermConstructorFactory =
  Factory.Sync.makeFactory<ShippingTermConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.lorem.word()),
    description: Factory.each(() => faker.lorem.sentence()),
    active: true,
  })

export const ShippingTermFactory = EntityFactory(
  ShippingTerm,
  ShippingTermConstructorFactory
)
